var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"physical-activity-progress border"},[_c('PAProgressTabs'),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }